export const checkDomainExists = async (domain) => {
  try {
    const res = await fetch(`https://dns.google/resolve?name=${domain}&type=A`);
    const data = await res.json();

    return data.Answer && data.Answer.length > 0;
  } catch (err) {
    return false;
  }
};
